import React, { useState } from "react";
import { Form, Alert, InputGroup, Button, ButtonGroup, Card } from "react-bootstrap";
import BookDataCareer from "../services/book.career";


const AddCareer = () => {
    const [title, setTitle] = useState(""); 
    const [jobcategary, setJobcategary] = useState(""); 
    const [city, setCity] = useState(""); 
    const [experience, setExperience] = useState(""); 
    const [mobile, setMobile] = useState(""); 
    const [emailaddress, setEmailaddress ] = useState ("");
    const [status, setStatus] = useState("Available");
    const [flag, setFlag] = useState(true);
    const [massage, setMassage] = useState({ error: false, msg: ""});



   const handleSubmit = async  (e) => {
       e.preventDefault();
       setMassage("");
       if(title === "" || mobile === "" || emailaddress === "" || experience === "" || city ==="" || jobcategary === "") {
           setMassage({error: true, msg : "All fields are mandatory!"});
           return;
       }
       const newBook = {
           title,
           mobile,
           emailaddress,
           experience,
           city,
           jobcategary,
           status
       }
       console.log(newBook);

       try {
           await BookDataCareer.addBooks(newBook);
           setMassage({ error: false, msg : "We wish you success!"});
       } catch (err) {
           setMassage({ error: true, msg: err.massage });
       }

       setTitle("");
       setMobile("");
       setEmailaddress("");
       setExperience("");
       setCity("");
       setJobcategary("");
   };
    return (
        <>
           <br/>
           <div className="album py-5">
           <div className="container">

<div className="row justify-content-center">
        <div className="col-md-7">
           <Card body >
               <br/>
               
            <center><h5 style={{textAlign: "center", color: "purple"}}>APPLY FOR JOB</h5></center>   
              
               <br/>
         <div className="card mb-4 box">
        {massage?.msg && (<Alert variant={massage?.error ? "danger": "success"}
         dismissible 
         onClose={() => setMassage("")}
         >
             {""}
             {massage?.msg}
         </Alert>
         )}
    
            <Form onSubmit={handleSubmit} >
                <Form.Group className="mb-3" controlId="formBookTitle">
                    <InputGroup>
                   
                    <Form.Control type="text"
                     placeholder="Enter your name"
                     value={ title}
                     onChange={(e) => setTitle(e.target.value)}
                     />
                    </InputGroup>
                </Form.Group>

               


                <Form.Group className="mb-3" controlId="formBookMobile">
                   
                    <Form.Control type="text"
                    placeholder="Contact number"
                    value={ mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    />
                   
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBookEmailaddress">
                    
                    <Form.Control type="text"
                     placeholder="Email address"
                     value={ emailaddress}
                     onChange={(e) => setEmailaddress(e.target.value)}
                     />
                 
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBookExperience">
                    
            
                    <Form.Control type="text"
                     placeholder="Experience"
                     value={ experience}
                     onChange={(e) => setExperience(e.target.value)}
                     />
                   
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBookCity">
                   
                    <Form.Control type="text"
                     placeholder="Location"
                     value={ city}
                     onChange={(e) => setCity(e.target.value)}
                     />
                   
                </Form.Group>


                <Form.Group className="mb-3" controlId="formBookJobcategary">
                    <Form.Control type="text"
                     placeholder="Job catagory"
                     value={ jobcategary}
                     onChange={(e) => setJobcategary(e.target.value)}
                     />
                   
                </Form.Group>

                {/* <ButtonGroup aria-lable="Basic example" className="mb-3">
                    <Button 
                    disabled={flag} variant="success" 
                    onClick={(e) => {
                    setStatus("Available");
                    setFlag(true);
                    }}
                    >
                        Available
                        </Button>
                        <Button variant="danger" 
                        onClick={(e) => {
                        setStatus("Not Available");
                        setFlag(false);
                        }}
                        >Not Available</Button>
        
                </ButtonGroup> */}

                        <div className="d-grid gap-2">
                            <Button variant="dark" type="Submit">
                           Submit
                            </Button>
                        </div>
                

            </Form>
          
        </div>
        </Card>
        </div>
        </div>
        </div>
        </div>
    
      
        </>


    )
}
export default AddCareer;